<!-- 各个彩种专家排行榜swipe组件 -->
<template>
    <div class="swipe-wrapper">
        <van-swipe class="card-swipe" :width="screenWidth * 0.88" :loop="false" :show-indicators="true">
            <van-swipe-item v-for="(item, index) in cardData" :key="index">
                <div class="card" :style="{ background: item.color }">
                    <van-row gutter="0" type="flex" justify="space-between">
                        <van-col span="9">
                            <div class="card-icon">{{ item.icon }}</div>
                            <h3>{{ item.title }}</h3>
                            <p class="van-ellipsis">{{ item.desc }}</p>
                        </van-col>
                        <van-col span="15">
                            <van-grid :border="false" :column-num="3">
                                <van-grid-item v-for="item in mavinTopArray[index]" :key="item.id" class="my-grid-item"
                                    @click="toMavinPage(item.id)">
                                    <van-image class="head-img" round lazy-load fit="cover"
                                        :src="'/img/headImg/' + item.headImg" />
                                    <div class="title van-ellipsis">{{ item.nickName }}</div>
                                </van-grid-item>
                            </van-grid>
                        </van-col>
                    </van-row>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
export default {
    name: 'MavinTopSwipe',
    data() {
        return {
            screenWidth: window.innerWidth,
            cardData: [
                { icon: '🎯', title: '单挑专家', desc: '精准推荐 大数据算法', color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
                { icon: '📊', title: '大底专家', desc: '数据分析 实时监控', color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
                { icon: '🏆', title: '综合专家', desc: '专家排行 分析师推荐', color: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' },
                { icon: '💡', title: '条件专家', desc: '智能选号 AI辅助决策', color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }
            ]
        }
    },
    props: ['data'],
    computed: {
        mavinTopArray() {
            const arrays = []
            arrays.push(this.data.dantiaoMavinList)
            arrays.push(this.data.dadiMavinList)
            arrays.push(this.data.zongheMavinList)
            arrays.push(this.data.tiaojianMavinList)
            return arrays
        },
    },
    mounted() {

        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth;
        });
    },
    methods: {
        
        // 去专家页
        toMavinPage(id){
            this.$router.push({
                path: '/mavin',
                query: {id}
            })
        },
    }
}
</script>

<style scoped>
/* 头像列表样式 */
.my-grid-item ::v-deep .van-grid-item__content {
    padding: 2px;
    background: none;
}

.head-img {
    width: 75%;
    display: block;
}

.title {
    display: block;
    font-size: 13px;
    color: #fff;
    line-height: 26px;
    width: 60px;
    text-align: center;
}

/* 手机端（小于 429px） */
@media screen and (max-width: 429px) {
    .title {
        width: 50px;
    }
}

/* 以下全是轮播器要用的样式 */
.swipe-wrapper {
    overflow: hidden;
    padding: 0px 0 0 0;
    margin-right: -16px;
    margin-left: -5px;
}

/* ✅ 关键样式：让第一张卡片紧贴左边 */
.card-swipe {
    padding-left: 0 !important;
    padding-right: 0;
}

/* ✅ 每个卡片：右侧间距产生间隔，左侧无间距 */
.van-swipe-item {
    padding-right: 12px;
    /* 卡片之间的间隔 */
    padding-left: 0;
    box-sizing: border-box;
    height: 126px;
    padding-left: 5px;
}

/* 卡片样式 */
.card {
    border-radius: 8px;
    padding: 20px 5px 20px 16px;
    color: #fff;
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
    height: 80px;
}

.card-icon {
    font-size: 36px;
    margin-bottom: 12px;
}

.card h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 6px;
}

.card p {
    font-size: 13px;
    opacity: 0.75;
    width: 100%;
    overflow: hidden;
    display: inline-block;
}

/* 自定义指示器样式 */
::v-deep .van-swipe__indicator {
    background: #f3f3f3;
    width: 6px;
    height: 6px;
}

::v-deep .van-swipe__indicator--active {
    background: #667eea;
    width: 12px;
    border-radius: 3px;
}
</style>